//shared-core/snackbar.service.ts
import { inject, Injectable, Type } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

interface SnackbarOptions<D> extends MatSnackBarConfig<D> {
  action?: string;
}

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  private snackBar = inject(MatSnackBar);

  show<T, D>(
    messageOrComponent: string | Type<T>,
    options?: SnackbarOptions<D>
  ): void {
    const defaultOptions: SnackbarOptions<D> = {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: ['custom-snackbar'],
    };

    const finalOptions = { ...defaultOptions, ...options };

    if (typeof messageOrComponent === 'string') {
      this.snackBar.open(
        messageOrComponent,
        finalOptions.action || undefined,
        finalOptions
      );
    } else {
      this.snackBar.openFromComponent(messageOrComponent, finalOptions);
    }
  }
}
